// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './components/App'
import router from './router'
import Vuetify from 'vuetify'
import store from './store'
import toastr from 'cxlt-vue2-toastr'
import * as VueGoogleMaps from 'vue2-google-maps'
import './helpers';
import './mixins';
import ability from './config/ability'
import { abilitiesPlugin } from '@casl/vue'

var toastrConfigs = {
  position: 'top right',
  showDuration: 1000,
  timeOut: 5000,
  progressBar: true,
  showMethod: 'fadeInUp',
  hideMethod: 'fadeOutDown',
}

Vue.use(abilitiesPlugin, ability)
Vue.use(Vuetify, {
  iconfont: 'mdi'
})
Vue.use(toastr, toastrConfigs)


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA92fLXWQSL1z3lVh3iz76KRPP6E7TAyBk',
    libraries: 'places', 
  }
})
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  console.log(from,to);
  next()
})

Vue.filter('filter', (value, format) => {
  switch (format) {
    case 'currency': {
      var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 /* this might not be necessary */
      });
      return formatter.format(value);
    }

    default:
      return value
  }
})
Vue.filter('currency', (value) => {
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 /* this might not be necessary */
  });
  return formatter.format(value);
})


/* eslint-disable no-new */
store.commit("clearLoading");
new Vue({
  //mixins: [loaderMixin],
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});


// WEBPACK FOOTER //
// ./src/main.js